<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :closeOnClickOverlay="false"
        @closed="$emit('close')"
    >
        <preloader :display="loader" />
        <template #header>
            <div class="dialog__header">
                <CompassIconButton icon="close" @click="$emit('close')" />
            </div>
        </template>
        <template #default>
            <div class="dialog__default">
                <div v-if="step === 1">
                    <SaasIcon icon="scheduler" width="56" height="56" class="mb-3" />
                    <div class="mb-3">
                        <span class="bold fs-5">{{
                            $l10n.__('Planification de rendez-vous')
                        }}</span>
                    </div>
                    <span class="fs-3">{{ $l10n.__('Informations sur votre compte email') }}</span>
                </div>
                <div v-else class="header-step2">
                    <span class="bold fs-5">{{ $l10n.__('Déconnexion compte email') }}</span>
                </div>

                <div v-if="step === 1" class="lh-20">
                    <div v-if="connected">
                        <el-divider class="my-3"></el-divider>
                        <nylas-scheduler></nylas-scheduler>
                    </div>
                    <el-divider class="my-3"></el-divider>
                    <div class="account mb-3">
                        <p class="bold mb-1">{{ $l10n.__('Compte') }}</p>
                        <p>{{ email }}</p>
                    </div>
                    <div class="status">
                        <p class="bold mb-1">{{ $l10n.__('Statut') }}</p>
                        <chip-label :color="statusChipColor" :label="statusLabel" gap="medium" />
                    </div>
                    <CompassPlainButton
                        :label="$t.__('popups.PopupSchedulerSettings.update_status')"
                        class="mt-2"
                        @click="onUpdateStatus"
                    />
                </div>
                <div v-else>
                    <p class="alert alert-danger mb-3">
                        {{
                            $l10n.__(
                                'Vous devez reconnecter votre compte email dans les 30 prochains jours pour garder les liaisons des emails de ce compte avec les fiches sociétés, opportunités et contacts.',
                            )
                        }}
                    </p>
                    <div class="flex-row">
                        <el-checkbox v-model="confirmLogout" class="mr-2"></el-checkbox>
                        <span class="pointer" @click="confirmLogout = !confirmLogout">
                            {{
                                $l10n.__(
                                    'Je confirme avoir pris connaissance du risque de perte de données.',
                                )
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="onCancelClicked"
                />
                <CompassButton
                    :label="labelBtnLogout"
                    type="primary-destructive"
                    :disabled="logoutDisabled"
                    class="ml-3"
                    @click="onLogoutClicked"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import ChipLabel from 'vcomponents/utilities/ChipLabel.vue';
import { getSchedulerMetadata } from 'api/onboarding/scheduler/onboardingScheduler';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import NylasScheduler from 'vcomponents/scheduler/NylasScheduler.vue';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
        Preloader,
        ChipLabel,
        NylasScheduler,
    },
    props: {
        defaultEmail: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            step: 1,
            email: this.defaultEmail,
            connected: true,
            confirmLogout: false,
            loader: false,
        };
    },
    computed: {
        statusChipColor() {
            return this.connected ? '#39CF86' : '#FF6060';
        },
        statusLabel() {
            return this.connected ? this.$l10n.__('Connecté') : this.$l10n.__('Non connecté');
        },
        labelBtnLogout() {
            return this.step === 1
                ? this.$l10n.__('Déconnexion')
                : this.$l10n.__('Je confirme la déconnexion');
        },
        logoutDisabled() {
            return this.step === 2 && !this.confirmLogout;
        },
    },
    methods: {
        defaultData() {
            this.confirmLogout = false;
            this.step = 1;
            this.email = '';
            this.connected = true;
        },
        onUpdateStatus() {
            //fetch status
            this.loader = true;
            getSchedulerMetadata()
                .then((res) => {
                    this.connected = res?.email;
                    this.email = res?.email?.email;
                    Push.success(this.$l10n.__('Le statut de votre compte a été mis à jour.'));
                })
                .catch(() => {
                    Push.error(this.$l10n.__('Erreur de synchronisation'));
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        onLogoutClicked() {
            if (this.step === 1) {
                this.step = 2;
            } else {
                //logout
                this.loader = true;
                SellsyJS.WebServiceCaller.post('?_f=prefsNylas&action=logout', {}, {}, () => {
                    this.$emit('close');
                    this.$emit('refresh');
                    this.defaultData();
                    this.loader = false;
                });
            }
        },
        onCancelClicked(e) {
            if (this.step === 1) {
                this.$emit('close');
                this.defaultData();
            } else {
                e.target.blur();
                this.step = 1;
            }
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.dialog {
    &__header {
        display: flex;
        justify-content: flex-end;
        padding: 24px 32px 0 32px;
    }

    &__default {
        padding-bottom: 24px;
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        padding: 0 32px 24px 32px;
    }
}
</style>
